module.exports = __webpack_public_path__ + "media/images/hero-f820287d.jpg";